import type { ExecutionStats } from "../../types/automation.types";

interface ExecutionHistoryStatsProps {
  stats: ExecutionStats;
  loading: boolean;
}

interface StatCardProps {
  label: string;
  value: number;
  icon: string;
  iconClass: string;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon, iconClass }) => (
  <div className="col-xl-3 col-md-6">
    <div className="card">
      <div className="card-body bg-white rounded-3">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <div className="flex-shrink-0 me-2">
              <span className="avatar avatar-lg rounded-circle bg-white d-flex align-items-center justify-content-center">
                <i className={`ti ${icon} ${iconClass} fs-28`} />
              </span>
            </div>
          </div>
          <div className="text-end">
            <p className="mb-1">{label}</p>
            <h4>{value}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const ExecutionHistoryStats: React.FC<ExecutionHistoryStatsProps> = ({
  stats,
  loading,
}) => {
  if (loading) {
    return (
      <div className="row">
        {[0, 1, 2, 3].map((i) => (
          <div className="col-xl-3 col-md-6" key={i}>
            <div className="card">
              <div className="card-body bg-white rounded-3">
                <div className="placeholder-glow">
                  <div
                    className="placeholder col-6 mb-2"
                    style={{ height: 12, borderRadius: 4 }}
                  />
                  <div
                    className="placeholder col-3"
                    style={{ height: 24, borderRadius: 4 }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="row">
      <StatCard
        label="Total Executions"
        value={stats.total}
        icon="ti-player-play"
        iconClass="text-primary"
      />
      <StatCard
        label="Completed"
        value={stats.completed}
        icon="ti-circle-check"
        iconClass="text-success"
      />
      <StatCard
        label="Failed"
        value={stats.failed}
        icon="ti-circle-x"
        iconClass="text-danger"
      />
      <StatCard
        label="Running"
        value={stats.running}
        icon="ti-clock"
        iconClass="text-info"
      />
    </div>
  );
};

export default ExecutionHistoryStats;
